// ─────────────────────────────────────────
// TOGGLE
// On/off switch with label. Used heavily across all steps.
// ─────────────────────────────────────────
export default function Toggle({ label, checked, onChange }) {
  return (
    <div className="flex items-center justify-between py-2.5 cursor-pointer" onClick={() => onChange(!checked)}>
      <span className="text-sm text-slate-700 select-none">{label}</span>
      <div className={`relative w-11 h-6 rounded-full transition-colors duration-200 shrink-0 ml-3 ${checked ? 'bg-blue-600' : 'bg-slate-200'}`}>
        <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${checked ? 'translate-x-5' : ''}`} />
      </div>
    </div>
  );
}